import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-datepicker/dist/react-datepicker.css";
import "./assets/css/style.css";
import AppRoutes from "./routes/AppRoutes";
import HRAttendanceModule from "./pages/HRAttendanceModule.js";
function App() {
  return <AppRoutes />;
  // return <HRAttendanceModule />;
}

export default App;
